// @flow
import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
import type { CharacterInfoPropsType, CharactersListPropsType } from '../../models/Character'
import { CharacterListItemComponent } from '@components/Character/CharacterListItem'
import { PageTitle } from '@components/shared/PageTitle'
export function CharacterList (props: CharactersListPropsType): React.Node {
  return (
    <CharacterListContainer>
      <PageTitle title={props.title}/>
      <DescriptionContainer>{props.description}</DescriptionContainer>
      <Characters>
        {props.characters.map((character: CharacterInfoPropsType, index: number): React.Node => (
          <CharacterListItemComponent {...character} key={index}/>
        ))}
      </Characters>
    </CharacterListContainer>
  )
}

const DescriptionContainer = styled.div`
  font-family: "Good Sans Regular";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px; /* 130.769% */
  letter-spacing: -0.3px;
  color: ${colors.white};
  ${(props: any): string => config(props).media.md`
    font-size: 16px;
  `}
`
const Characters = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
    
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    &>* {
        flex: 1 1 500px;
    }
      margin-top: 38px;
  `}
    ${(props: any): string => config(props).media.lg`
      margin-top: 42px;
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
const CharacterListContainer = styled.div`
    display: flex;
    flex-direction: column;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
